import { memo } from 'react';
import CharacterCell from './CharacterCell';
import type { CharStatus } from '../../types/typing';

interface LineRowProps {
  chars: string[];
  lineStartIndex: number;
  getCharStatus: (index: number) => CharStatus;
  lineNumber: number;
  /**
   * Propagated from useTypingSession. Changes every keystroke, busting this
   * memo so getCharStatus is re-invoked for each cell. CharacterCell.memo
   * then short-circuits cells whose status hasn't changed — O(changed cells)
   * DOM work, not O(total cells).
   */
  renderTick: number;
}

const LineRow = memo(function LineRow({
  chars,
  lineStartIndex,
  getCharStatus,
  lineNumber,
}: LineRowProps) {
  return (
    <div className="line-row" data-line={lineNumber}>
      <span className="line-number">{lineNumber}</span>
      <span className="line-chars">
        {chars.map((ch, localIdx) => {
          const globalIdx = lineStartIndex + localIdx;
          return (
            <CharacterCell
              key={globalIdx}
              char={ch}
              status={getCharStatus(globalIdx)}
            />
          );
        })}
      </span>
    </div>
  );
});

export default LineRow;
